import { AppState } from 'Store'

const getOne = (state: AppState) => state.registratorCabinet.orderEdit.editRbidosRequest
const getEditRbidosLead = (state: AppState) => state.registratorCabinet.orderEdit.lead
const getSocketIds = (state: AppState) => state.registratorCabinet.orderEdit.socketIds
const getSocketRequest = (state: AppState) => state.registratorCabinet.orderEdit.socketRequest
const getDocumentUpdate = (state: AppState) => state.registratorCabinet.orderEdit.documentsUpdated
const getSberIdInfo = (state: AppState) => state.registratorCabinet.orderEdit.sberIdInfo
const getMccCodes = (state: AppState) => state.registratorCabinet.orderEdit.mccCodes
const getMccGroup = (state: AppState) => state.registratorCabinet.orderEdit.mccGroup

export const orderEditSelectors = {
	getOne,
	getEditRbidosLead,
	getSocketIds,
	getSocketRequest,
	getDocumentUpdate,
	getSberIdInfo,
	getMccCodes,
	getMccGroup,
}
